module.exports = __webpack_public_path__ + "static/media/Bronze.08266abc.svg";